// pages/Contact.js

import React from 'react';

function Contact() {
  return <>
    <h2>Contact</h2>
    <br/>
    <p className="center-p">The quickest way to get in touch would be through <a target="_blank" rel="noreferrer" href="https://t.me/delaxiox">Telegram</a>.</p>
    <br/>
    <br/>
    <h3>Things I Like To Do</h3>
    <div className="all-center-paragraphs">
    <br/>
    <p>Build Websites</p>
    <br/>
    <p>Help Creatives Market Themselves Online</p>
    <br/>
    <p>Educate Artists On The Business Side Of Things</p>
    <br/>
    <p>Assist Furry Conventions With Websites / Other Technology</p>
    <br/>
    <p>Meet New People</p>
    <br/>
    <p>Eat Food</p>
    </div>
  </>; 
}

export default Contact;